import postDataAsync from './postDataAsync'
import getCsrfToken from '@newswebsiteapp/shared/lib/getCsrfToken'
import swal from 'sweetalert2'
import { googleRecaptcha_disabled_tokenReturnedByJs } from '@newswebsiteapp/shared/lib/googleRecaptchaTokenForAction'

const usedRecaptchaTokens = []
// const usedCollectJsTokens = []

export default function collectJs_handleResponse_implementation(args) {
  const {
    url,
    response,
    // submittingFinalForm,
    /// ///
    lastValidDataRef_formData,
    lastValidDataRef_recaptchaToken,
    /// ///
    setFormError,
    setSubmittingFinalForm,
    // packageForm_updateState,

    // to reset on error
    collectJS,
    recaptchaInstanceRef,
    setRecaptchaToken,
    recaptchaSiteKey_disabled,
    otherBodyData,
    onSuccess,
    onError,
  } = args

  const setFormError_and_setSubmittingFinalForm = (message) => {
    setFormError(message)
    setSubmittingFinalForm(false)
  }

  const formData = lastValidDataRef_formData.current
  const recaptchaToken = lastValidDataRef_recaptchaToken.current

  const logged = { ...args, formData, recaptchaToken }
  console.log('onSubmit => collectjs onResponse', logged)
  console.log('onSubmit => collectjs onResponse JSON.stringify', JSON.stringify({ formData, recaptchaToken, response }))

  // https://github.com/react-hook-form/react-hook-form/blob/97c3ba46b9d34245a9a8c9febc953809f667944b/src/logic/createFormControl.ts#L1116
  // using onInvalid will not help
  if (!formData) {
    throw new Error('formData is empty, impossible')
  }
  if (!recaptchaSiteKey_disabled && !recaptchaToken) {
    setFormError_and_setSubmittingFinalForm('Recaptcha is invalidated while we were tokenizing the credit card. Please pass again and press "Submit"')
    return
  }

  const { token: nmi_token } = response

  // NOTE: in callback will be invalid
  // if (!submittingFinalForm) { return } // so, onSubmit was called

  if (!collectJS) {
    throw new Error('collectJS is empty')
  }

  if (!recaptchaSiteKey_disabled && !recaptchaInstanceRef.current) {
    throw new Error('impossible, recaptchaInstanceRef.current is empty')
  }

  if (!nmi_token) {
    setFormError_and_setSubmittingFinalForm('Payment token is empty. This could be due to an invalid or incomplete field')
    return
  }

  const checkUsedOrPush = (args) => {
    const { type, buffer, token } = args
    if (buffer.includes(token)) {
      throw new Error(`used ${type} token ${token} (buffer ${buffer})`)
    }
    buffer.push(token)
  }

  if (!recaptchaSiteKey_disabled) {
    checkUsedOrPush({
      type: 'recaptcha',
      buffer: usedRecaptchaTokens,
      token: recaptchaToken,
    })
  }

  // checkUsedOrPush({
  //   type: 'nmi',
  //   buffer: usedCollectJsTokens,
  //   token: nmi_token,
  // })

  postDataAsync({
    url,
    csrfToken: getCsrfToken(),
    bodyData: {
      ...formData,
      ...otherBodyData,
      new_google_recaptcha_token: recaptchaSiteKey_disabled ? googleRecaptcha_disabled_tokenReturnedByJs : recaptchaToken,
      nmi_token,
    },
    onError: (message) => {
      onError()
      setFormError_and_setSubmittingFinalForm(message)

      lastValidDataRef_formData.current = null
      setRecaptchaToken(null)
      lastValidDataRef_recaptchaToken.current = null // not needed actually, it done in setRecaptchaToken(null)

      if (recaptchaSiteKey_disabled) {
        if (recaptchaInstanceRef.current) { throw new Error('should be empty') }
      } else {
        // prevent error on second send
        //
        // DEBUG -- : AppVerifyRecaptcha: json = {"success"=>false, "error-codes"=>["timeout-or-duplicate"]}
        // DEBUG -- : AppVerifyRecaptcha: result = {:validator_result=>false, :new_google_recaptcha_token=>"asdf", :minimum_score=>0.5}
        //
        // FIX: LOOOOOL it doesnt emit handleReaptchaErrorOrExpire !!!!
        recaptchaInstanceRef.current.reset()
      }

      // not always, but MAYBE the error was throw AFTER Helpers::Nmi::Sale.sale
      // so, MAYBE token is invalid
      // if use again - Helpers::Nmi::Sale.sale will throw {"response"=>"3", "responsetext"=>"Duplicate transaction REFID:1198013191", "authcode"=>"", "transactionid"=>"", "avsresponse"=>"", "cvvresponse"=>"", "orderid"=>"", "type"=>"sale", "response_code"=>"300"}
      //
      // therefore, I need to do
      collectJS.retokenize()
    },
    onSuccess: ({ title, text }) => {
      onSuccess()

      // setFormError(null)
      setSubmittingFinalForm(false)
      swal.fire({
        title,
        text,
        icon: 'success',
        confirmButtonText: 'Close',
        onClose: function () {
          setTimeout(() => {
            // https://stackoverflow.com/questions/18967532/window-location-reload-not-working-for-firefox-and-chrome
            const forcedReload = true
            window.location.reload(forcedReload)
          })
          // window.location.href = $('[data-page-to-return-path]')
          //   .expectLength()
          //   .data('page-to-return-path')
        },
      })
    },
  })
}
